/*
 * @Description:外调车运单
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2025-04-14 11:26:46
 * @LastEditors: didan
 */
// 运单来源
export const forms = [
  { label: 'pc端开单', value: 'WEB' },
  { label: '调度端开单', value: 'WX_DISPATCH' },
  { label: '司机扫码', value: 'WX_DRIVER' },
  { label: 'pc端导表', value: 'EXCEL' },
  { label: 'openapi', value: 'OPENAPI' },
  { label: '智能录单', value: 'AI' },
];

// 支付状态
export const pay = [
  { label: '待申请', value: 'INIT' },
  { label: '网货审核', value: '1' },
  { label: '网货拒绝', value: '3' },
  { label: '财务审核', value: 'PAYING' },
  { label: '财务拒绝', value: 'REFUSE' },
  { label: '部分支付', value: 'part' },
  { label: '全部支付', value: 'all' },
  { label: '支付完成', value: 'SUCCESS' },
  { label: '已过期', value: 'EXPIRED' },
];

// 运单支付方式
export const payType = [
  { label: '全部', value: '' },
  { label: '运费给司机', value: '1' },
  { label: '运费给经纪人', value: '2' },
];

// ETC
export const etc = [
  { label: '全部', value: '' },
  { label: '有ETC', value: '1' },
  { label: '无ETC', value: '0' },
];

// 分油
export const oil = [
  { label: '全部', value: '' },
  { label: '未分油', value: '0' },
  { label: '已分油', value: '1' },
];

// 轨迹
export const trajectory = [
  { label: '全部', value: '' },
  { label: '无轨迹', value: '0' },
  { label: '自动装货失败', value: 1 },
  //   { label: '自动卸货失败', value: 2 },
];

// 微信机器人
export const robot = [
  { label: '全部', value: '' },
  { label: '已添加', value: '1' },
  { label: '未添加', value: '0' },
];

// 载货长度
export const extent = [
  { label: '全部', value: '' },
  { label: '18.5', value: '18.5' },
  { label: '17.5', value: '17.5' },
  { label: '16', value: '16' },
  { label: '15', value: '15' },
  { label: '13.7', value: '13.7' },
  { label: '13', value: '13' },
  { label: '12.5', value: '12.5' },
  { label: '11.7', value: '11.7' },
  { label: '9.6', value: '9.6' },
  { label: '8.7', value: '8.7' },
  { label: '8.2', value: '8.2' },
  { label: '7.7', value: '7.7' },
  { label: '6.8', value: '6.8' },
  { label: '6.2', value: '6.2' },
  { label: '5', value: '5' },
  { label: '4.2', value: '4.2' },
  { label: '3.8', value: '3.8' },
  { label: '2.7', value: '2.7' },
  { label: '1.8', value: '1.8' },
  { label: '1.6', value: '1.6' },
  { label: '1.4', value: '1.4' },
];

export const exception = [
  { label: '无异常', value: 1 },
  { label: '运力审核异常', value: 2 },
  { label: '其他异常', value: 3 },
];
